import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-primary/30 bg-surface py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-77" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-78" data-mp="9t1nh6wuedbj">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-primary bg-background p-8 shadow-2xl shadow-foreground/10 sm:p-12" data-id="element-79" data-mp="etpmaerbbygb">
          <span className="inline-flex rounded-full border border-highlight/50 bg-surface p-4 text-highlight" data-id="element-80" data-mp="sn6xnc9ui4v9">
            <ShieldCheckIcon className="glow-led h-10 w-10" aria-hidden="true" data-id="element-81" data-mp="12j0e36qoqiib" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold uppercase tracking-tight text-foreground sm:text-4xl" data-id="element-82" data-mp="17i4qs7ctiyde">
            7-Day <span className="text-accent" data-id="element-83" data-mp="25syjqqmtreg6">Guarantee</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-84" data-mp="20t3xx1hwpf1z">
            Explore all 6 volumes and 5 bonuses this week. If the materials don&apos;t fit your classroom
            needs,{' '}
            <span className="font-extrabold text-accent" data-id="element-85" data-mp="1rsfgrxx7uykv">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}